import { render, staticRenderFns } from "./VueRenderComponent.vue?vue&type=template&id=25ebdc3d&scoped=true&"
import script from "./VueRenderComponent.vue?vue&type=script&lang=js&"
export * from "./VueRenderComponent.vue?vue&type=script&lang=js&"
import style0 from "./VueRenderComponent.vue?vue&type=style&index=0&id=25ebdc3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ebdc3d",
  null
  
)

export default component.exports